import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.b2{gap:16px;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.b3{display:block;}.ssr-plugin'
import '.b4{padding-bottom:48px;}.ssr-plugin'
import '.b5{text-align:center;}.ssr-plugin'
import '.b6{display:inline-block;}.ssr-plugin'
import '.b7{margin-bottom:36px;}.ssr-plugin'
import '.b8{gap:8px;}.ssr-plugin'
import '.b9{margin-top:16px;}.ssr-plugin'
import { FC } from 'react'
import { Layout } from './Layout'
import { Navigation } from '../components/Navigation'
import { Canva } from '../components/Canva'
import { Text } from '../components/Text'
import { useTheme } from '../providers/useTheme'
import { useAppCtx } from '../providers/useAppCtx'
import { styled } from 'inlines'
import { useContentQuery } from '../hooks/useContentQuery'
import { useIsMobile } from '../hooks/useIsMobile'
import { Html } from '../components/Html'
import {
  replaceMustachesInString,
  useMustacheIndex,
} from '../hooks/useTranslations'
import { useScrollToTop } from '../hooks/useScrollToTop'

export type ContentProps = {
  'aria-label'?: {
    nav: string
    footer: string
  }
}

export const Content: FC<ContentProps> = ({
  'aria-label': ariaLabelProp = {
    nav: 'Main navigation',
    footer: 'Footer navigation',
  },
}) => {
  const { languages, votesCount } = useAppCtx()
  const { data: sequence = {} } = useContentQuery('sequence')
  const mustacheIndex = useMustacheIndex()
  const { colors } = useTheme()
  const isVoting = sequence?.sequenceType === 'voting'

  const isMobile = useIsMobile()

  useScrollToTop()

  return (
    <Layout
      style={{
        padding: '32px 24px 96px',
        gap: 32,
      }}
    >
      <Layout.Navbar>
        <Navigation
          as="nav"
          aria-label={ariaLabelProp.nav}
          isCartVisible={isVoting}
          isExpandable
          cartItems={votesCount}
          languages={languages}
        />
      </Layout.Navbar>

      {sequence?.media && (
        <Layout.Top
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            flex: 1,
            maxWidth: 480,
            maxHeight: 296,
          }}
        >
          <Canva
            src={sequence?.media?.src}
            size={{
              width: 180,
              height: 180,
            }}
          />
        </Layout.Top>
      )}

      <Layout.Middle>
        <div className="a i d c b2 h"
        >
          {sequence?.prompt && (
            <Text
              color={'gradient'}
              variant="title"
              isMultiline
              style={{ textAlign: 'center' }}
            >
              {replaceMustachesInString(sequence?.prompt, mustacheIndex)}
            </Text>
          )}

          {sequence?.details && (
            <Html color={colors.textSecondary}>
              {replaceMustachesInString(sequence?.details, mustacheIndex)}
            </Html>
          )}

          {sequence?.contestants && (
            <div className="h b3 b4 b5"
            >
              {sequence?.contestants?.map((contestant, idx) => {
                return (
                  <div className="b6 b7 h"
                    style={{
                      margin: isMobile ? 16 : 24,
                      maxWidth: isMobile ? '320px' : 174,
                    }}
                    key={idx}
                  >
                    <Canva
                      src={contestant?.image?.src}
                      size={
                        isMobile
                          ? {
                              width: 300,
                              height: 300,
                            }
                          : {
                              width: 'auto',
                              height: 'auto',
                            }
                      }
                    />

                    <div className="a i h b8 b9"
                    >
                      <Text
                        as="h3"
                        color={colors.textPrimary}
                        variant="heading"
                        isMultiline
                        //  aria-label={label}
                        style={{
                          userSelect: 'none',
                        }}
                      >
                        {contestant?.name}
                      </Text>

                      <Text
                        variant="display-regular"
                        color={colors.textSecondary}
                        isMultiline
                        style={{
                          userSelect: 'none',
                        }}
                      >
                        {contestant?.song}
                      </Text>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </Layout.Middle>

      <Layout.Footer>
        <Navigation
          as="footer"
          aria-label={ariaLabelProp.footer}
          languages={languages}
        />
      </Layout.Footer>
    </Layout>
  )
}
